<div class="popup-container">
    <div>
        <div class="d-flex heading-box">
            <div class="flex-grow-1 v-center">{{data.title}}</div>
            <div class="v-center"><mat-icon class="close-icon" (click)="closePopup()" (keydown.enter)="closePopup()">close</mat-icon></div>
        </div>
        <div class="popup-body px-4 pt-4">
            <div class="row cron-input-container">
                <label for="cronInput" class="cron-label">Cron Expression</label>
                <cron-editor [formControl]="cronForm" [options]="cronOptions"></cron-editor>
              </div>
            <div class="row button-space mx-0 justify-content-end">
                <button type="button" class="btn  btn-transparent-outlined" (click)="closePopup()">Cancel</button>
                <button type="button" class="btn  btn-accello-primary" (click)="saveCron()">Save</button>
            </div>
        </div>
    </div>
</div>
